export const APPERROR_GENERIC_ERROR = 'APPERROR_GENERIC_ERROR';

export const APPERROR_NO_USER_CONFIGS_DATA = 'APPERROR_NO_USER_CONFIGS_DATA';
export const APPERROR_NO_USER_ROLE = 'APPERROR_NO_USER_ROLE';

export class AppError extends Error {
    public errorCode: string;
    public details: any;

    constructor(errorCode: string, message: string = null, details: any = null) {
        super(message);
        this.errorCode = errorCode;
        this.details = details;

        if(message){
          this.message = message;
        }
    }
}
